import React from 'react';
import { useNavigate } from 'react-router-dom';

function FormHeader({ selectedTeamId }) {
  const navigate = useNavigate();

  return (
    <div className="form-header">
      <button
        onClick={() => navigate(`/team/${selectedTeamId}`)}
        className="back-button"
      >
        ← Back to Team Portal
      </button>
      <h1>Create Graphic</h1>
      <p>Design your game day graphic</p>
    </div>
  );
}

export default FormHeader;
